import { motion } from "framer-motion";
import { Check } from "lucide-react";

const steps = [
  { number: 0, label: "Company Info" },
  { number: 1, label: "Contact Details" },
  { number: 2, label: "Description" },
  { number: 3, label: "Additional Info" },
  { number: 4, label: "Declaration" },
  { number: 5, label: "Preview" },
];

export default function RegistrationStepper({ currentStep }) {
  return (
    <div className="px-4 mb-8 w-full">
      <div className="flex justify-between items-start w-full">
        {steps.map((step, index) => {
          const isActive = currentStep === step.number;
          const isCompleted = currentStep > step.number;
          const isLast = index === steps.length - 1;
          const isFirst = index === 0;
          const leftFilled = !isFirst && currentStep >= step.number;
          const rightFilled = !isLast && isCompleted;

          return (
            <div key={step.number} className="flex flex-1 flex-col items-center min-w-0 px-0.5 sm:px-1">
              <div className="grid grid-cols-[1fr_auto_1fr] items-center w-full">
                <div className="h-0.5 bg-gray-200 rounded-full overflow-hidden">
                  {!isFirst && (
                    <motion.div
                      initial={false}
                      animate={{ width: leftFilled ? "100%" : "0%" }}
                      transition={{ duration: 0.3 }}
                      className="h-full bg-purple-500"
                    />
                  )}
                </div>
                <motion.div
                  initial={false}
                  animate={{ scale: isActive ? 1.1 : 1 }}
                  className={`mx-1 sm:mx-2 relative flex justify-center items-center w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 rounded-full transition-all ${
                    isActive
                      ? "text-white bg-purple-500 shadow-lg"
                      : isCompleted
                      ? "text-white bg-purple-500"
                      : "text-gray-600 bg-gray-200"
                  }`}
                >
                  {isCompleted ? (
                    <Check size={16} className="text-white sm:w-5 sm:h-5" />
                  ) : (
                    <span className="text-[10px] sm:text-xs md:text-sm font-bold">{index + 1}</span>
                  )}
                </motion.div>
                <div className="h-0.5 bg-gray-200 rounded-full overflow-hidden">
                  {!isLast && (
                    <motion.div
                      initial={false}
                      animate={{ width: rightFilled ? "100%" : "0%" }}
                      transition={{ duration: 0.3 }}
                      className="h-full bg-purple-500"
                    />
                  )}
                </div>
              </div>
              <span
                title={step.label}
                className={`mt-1.5 sm:mt-2 text-[9px] sm:text-[10px] md:text-xs font-medium transition-colors text-center leading-tight line-clamp-2 w-full px-0.5 ${
                  isActive
                    ? "text-purple-500"
                    : isCompleted
                    ? "text-gray-600"
                    : "text-gray-500"
                }`}
              >
                {step.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
